"use client"

import React from "react"
import { NotificationItemTemplate } from "./NotificationItemTemplate"
import { FragmentType, graphql, useFragment } from "@/gql"
import { NotificationActor } from "./NotificationActor"
import { Text } from "@/elements"
import { useRouter } from "next-nprogress-bar"
import { UserNotificationFeedItem } from "@/gql/graphql"
import Image from "next/image"
import { BriefcaseIcon } from "@/icons/outline"

const JobApplicationViewedFragment = graphql(`
  fragment JobApplicationViewed on StreamNotificationFeedAggregatedActivity {
    id
    isRead
    isSeen
    activities {
      id
      time
      target {
        __typename
        ... on JobPosting {
          id
          title
          coverImage {
            thumbnailUrl
          }
        }
      }
      object {
        __typename
        ... on JobApplication {
          id
        }
      }
      actor {
        __typename
        id
        name
        ... on User {
          creative {
            __typename
            id
            name
          }
        }
        ...NotificationActor
      }
    }
  }
`)

interface Props {
  onClick: (type: UserNotificationFeedItem) => void

  item: FragmentType<typeof JobApplicationViewedFragment>
}

export const JobApplicationViewed: React.FC<Props> = props => {
  const item = useFragment(JobApplicationViewedFragment, props.item)
  const router = useRouter()
  const { onClick } = props
  const activity = item.activities?.[0]
  const actor = activity?.actor
  const actorName = actor?.__typename === "User" && actor?.creative?.name ? actor?.creative?.name : actor?.name

  const target =
    activity?.target?.__typename === "ClientJobPosting" || activity?.target?.__typename === "CreativeJobPosting"
      ? activity?.target
      : null

  const handleClick = () => {
    onClick(UserNotificationFeedItem.JobApplicationShortlisted)
    router.push(`/jobs/applications?id=${target?.id}`)
  }

  return (
    <NotificationItemTemplate
      isSeen={item.isSeen}
      LeftComponent={
        actor && target?.coverImage?.thumbnailUrl ? (
          <Image
            src={target?.coverImage?.thumbnailUrl}
            className="size-8 rounded-full"
            alt={target?.title || "Job post"}
          />
        ) : (
          <div className="flex size-8 items-center justify-center rounded-full bg-bg-3">
            <BriefcaseIcon className="size-4 stroke-fg-2" />
          </div>
        )
      }
      onClick={handleClick}
      TextContent={
        <Text element="span" onClick={handleClick}>
          Your application to &quot;
          <Text element="span" className="!font-medium">
            {target?.title}
          </Text>
          &quot; was viewed.
        </Text>
      }
      time={activity?.time}
    />
  )
}
